export default function ({ app }) {
    app.i18n.setLocale('he')
}
